import { TOKEN, USUARIO, PERFIL, PERMISSOES } from '@/common/constants'

const getters = {
  getToken: (state) => state.token,
  getRotinasPermitidasDoUsuario: (state) => {
    return state.permissoes.map((permissao) => {
      return permissao.rotina.nome
    })
  },
  usuarioEstaLogado: (state) => !!state.token,
  verificaSeTemPermissao: (state) => (rotinaId, operacao) =>
    state.permissoes.some(
      (permissao) => permissao.rotina.id === rotinaId && permissao.operacoes.includes(operacao)
    ),
  verificaSePodeAcessarRotina: (state) => (rotinaId) =>
    state.permissoes.some((permissao) => permissao.rotina.id === rotinaId)
}

const state = () => ({
  token: localStorage.getItem(TOKEN) || '',
  usuario: JSON.parse(localStorage.getItem(USUARIO)) || {},
  perfil: JSON.parse(localStorage.getItem(PERFIL)) || {},
  permissoes: JSON.parse(localStorage.getItem(PERMISSOES)) || []
})

const actions = {
  logOut: () => {
    localStorage.clear()
    location.reload()
  }
}

const mutations = {
  setToken(state, token) {
    localStorage.setItem(TOKEN, token)
    state.token = token
  },

  setUsuario(state, usuario) {
    localStorage.setItem(USUARIO, JSON.stringify(usuario))
    state.usuario = usuario
  },

  setPerfil(state, perfil) {
    localStorage.setItem(PERFIL, JSON.stringify(perfil))
    state.perfil = perfil
  },

  setPermissoes(state, permissoes) {
    localStorage.setItem(PERMISSOES, JSON.stringify(permissoes))
    state.permissoes = permissoes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
